module.exports = __webpack_public_path__ + "static/media/obbligo-formativo.d077fa0e.odt";